import { Button, Col, List, Row, Spin, Upload, UploadProps } from "antd";
import Paragraph from "antd/lib/typography/Paragraph";
import ApplicationPageProps from "common/models/ApplicationPageProps";
import { SalePledgeJobClient } from "common/services/microservices/sales-client";
import React from "react";
import { useState } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { MicroservicesEndpoint } from "common/services/ApiServerService";
import { authenticatedClient } from "core/components/AuthProvider";
import { InsightsClient, UserLogEvent } from "common/services/microservices/cron-boss-client";
import { CronTaskStateType } from "common/services/microservices/licenses-client";
import { waitFor } from "common/utilities/waitFor";

export default function SalePledgeReportUploadTool(props: ApplicationPageProps) {
  const [resultMessage, setResultMessage] = useState<UserLogEvent[]>();
  const [successCountMessage, setSuccessCount] = useState<UserLogEvent>();
  const [isSpinning, setSpinning] = React.useState<boolean>(false);

  let failureMessage = new UserLogEvent({ eventDatetime: new Date(), eventMessage: "Task failed to process report." });

  const goodBoyFileTypes = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
  ];

  const uploadProps: UploadProps = {
    accept: goodBoyFileTypes.join(", "),
    multiple: false,
    maxCount: 1,
    onChange(info) {
      const { status } = info.file;

      if (status === "done") console.log("done");
      else if (status === "error") console.log("error");
    },
    customRequest: (options) => {
      setSpinning(true);
      authenticatedClient(MicroservicesEndpoint.sales, SalePledgeJobClient)
        .then(async (c) => {
          let url = await c.getUploadUrl();
          let uploadRes = await fetch(url.presignedUrl, {
            headers: {
              "Content-Type": "application/octet-stream",
            },
            method: "PUT",
            body: options.file,
          });

          if (!uploadRes.ok) {
            options.onError?.(undefined!, uploadRes.statusText);
            return;
          }

          let taskGuid = await c.processReport(url.objectGuid);
          options.onSuccess?.(uploadRes.statusText, undefined!);

          getUserLogs(taskGuid.guid);
        })
        .catch(() => {
          options.onError?.(undefined!, "Failed");
        });
    },
  };

  const getUserLogs = async (guid: string) => {
    authenticatedClient(MicroservicesEndpoint.cronboss, InsightsClient).then(async (c) => {
      let res = await c.getTaskReport(guid);
      console.log(res);
      await waitFor(async () => {
        let taskState = await c.getTaskReport(guid);
        if (taskState.cronTaskStateType == CronTaskStateType.Success) {
          setSpinning(false);
          setSuccessCount(taskState.userLogs.pop());
          setResultMessage(taskState.userLogs);
          return true;
        } else if (taskState.cronTaskStateType == CronTaskStateType.Failure) {
          setSpinning(false);
          setSuccessCount(failureMessage);
          setResultMessage(taskState.userLogs);
          return false;
        }
      });
    });
  };

  return (
    <Paragraph className="container my-3">
      <Row gutter={[16, 24]}>
        <Col offset={8}>
          <h3>Upload a Sale Pledge Report</h3>
        </Col>
      </Row>
      <Row gutter={[16, 24]} className="my-3">
        <Col offset={8} span={4}>
          Select a File
        </Col>
        <Col span={7}>
          <Upload {...uploadProps}>
            <Button icon={<UploadOutlined />} style={{ width: "100% " }}>
              Browse
            </Button>
          </Upload>
        </Col>
      </Row>
      <Row justify="center">
        <Spin spinning={isSpinning}></Spin>
      </Row>
      {resultMessage && (
        <List
          size="small"
          header={<div>{successCountMessage?.eventMessage}</div>}
          bordered
          dataSource={resultMessage}
          renderItem={(item) => <List.Item>{item.eventMessage}</List.Item>}
        />
      )}
    </Paragraph>
  );
}
